export default "__VITE_ASSET__d52348e0__"